// File: src/components/layout/PageLayout.jsx
// Updated with mobile menu state management

import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';

const PageLayout = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="app-with-layout">
      <Header onMobileMenuToggle={toggleMobileMenu} />
      <div className="app-body">
        <Sidebar 
          isMobileOpen={isMobileMenuOpen} 
          onClose={closeMobileMenu}
        />
        <main className="main-content-with-sidebar">
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default PageLayout;